module.exports = __webpack_public_path__ + "static/media/related-blog2.47ed4ee0.jpg";